const config = {
    success: 'Your application has been submitted successfully.',
    Application_No: 'Your application number is ',
    notice: 'The Confirmation Email Notification is sent to your registered email.',
    return: 'Return to the Home Page',
    // Gabriel End Here 29-May-2023
};
export default config;
